import React, { useState, useContext, useEffect, useMemo } from 'react';
import {
  CompositeView,
  CrudContext,
  GridView,
  SimpleView,
  usePromise,
  FilterWidget,
  FormRangePicker,
  MasterDetailForm,
  Button,
} from '@digital/ui';
import { Collapse } from 'antd';
import { dateFormat } from '../../../helpers/dateTimeFormats';
import { FitroOrdemCompraPorStatusCodigo } from '@app/api/sas/ordemCompra';

interface RelatorioOrdemCompraFiltrosProps {
  onUpdate(filtros: FitroOrdemCompraPorStatusCodigo): void;
}

const RelatorioOrdemCompraFiltros = ({ onUpdate }: RelatorioOrdemCompraFiltrosProps) => {
  const { selectedItem } = useContext(CrudContext);
  const { Panel } = Collapse;

  const [update, setUpdate] = useState(true);
  const [periodoInicio, setPeriodoInicio] = useState(null);
  const [periodoFim, setPeriodoFim] = useState(null);

  return (
    <FilterWidget
      active={[]}
      actions={[
        <Button
          type="primary"
          key="filterBtn"
          onClick={() => {
            const filtro = {
              consultaStatusConcluido: true,
              periodoInicio: periodoInicio,
              periodoFim: periodoFim,
              codigos: [12, 13],
            } as FitroOrdemCompraPorStatusCodigo;
            onUpdate(filtro);
          }}>
          Pesquisar
        </Button>,
      ]}>
      <MasterDetailForm>
        <FormRangePicker
          value={[periodoInicio, periodoFim]}
          startName="dataInicio"
          endName="dataFinal"
          format={dateFormat}
          label="Período"
          span={4}
          onChange={dates => {
            setPeriodoInicio(dates[0]);
            setPeriodoFim(dates[1]);
          }}
        />
      </MasterDetailForm>
    </FilterWidget>
  );
};

export default RelatorioOrdemCompraFiltros;
